const svgPageNavIcon = `
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="13" cy="13" r="13" fill="#4E505B" fill-opacity="0.05"/>
    <circle cx="13" cy="13" r="12.7708" stroke="black" stroke-opacity="0.19" stroke-width="0.458333"/>
    <path d="M12.658 8C12.212 8 11.8484 8.3636 11.8484 8.80958C11.8484 9.25556 12.212 9.61916 12.658 9.61916H17.506C17.9519 9.61916 18.3155 9.25556 18.3155 8.80958C18.3155 8.3636 17.9519 8 17.506 8H12.658Z" fill="#4E505B"/>
    <path d="M7.13581 12.4023C7.1212 12.4216 7.11647 12.4507 7.10673 12.4751C7.08251 12.5188 7.06304 12.5672 7.04856 12.6156C7.03882 12.6447 7.02435 12.6689 7.01461 12.698C7.00974 12.7271 7.01461 12.7513 7.01461 12.7804C7.01461 12.8046 7 12.8288 7 12.8532C7 12.8774 7.01461 12.9016 7.01461 12.9259C7.01948 12.955 7.00974 12.9792 7.01461 13.0083C7.01948 13.0374 7.03882 13.0616 7.04856 13.0907C7.06317 13.1391 7.08251 13.1877 7.10673 13.2312C7.12134 13.2554 7.12134 13.2797 7.13581 13.304L8.75022 15.728C8.90538 15.9607 9.16224 16.0867 9.42413 16.0867C9.57928 16.0867 9.73443 16.043 9.87011 15.9509C10.2434 15.7036 10.3403 15.1995 10.0932 14.831L9.31268 13.6627H17.5058C17.9518 13.6627 18.3154 13.2991 18.3154 12.8531C18.3154 12.4072 17.9518 12.0436 17.5058 12.0436H9.31752L10.098 10.8753C10.3453 10.5019 10.2434 10.0027 9.87496 9.75538C9.50163 9.50811 9.00236 9.60997 8.75507 9.97844L7.13581 12.4023Z" fill="#4E505B"/>
    <path d="M17.506 16.082H12.658C12.212 16.082 11.8484 16.4456 11.8484 16.8916C11.8484 17.3377 12.212 17.6964 12.658 17.6964H17.506C17.9519 17.6964 18.3155 17.3328 18.3155 16.8869C18.3155 16.4407 17.9519 16.082 17.506 16.082Z" fill="#4E505B"/>
  </svg>
`;

const PageNavController = {
  sections: document.querySelectorAll('[data-section-name]'),
  options: { theshold: 0.25, rootMargin: '0px 0px -100% 0px' },

  init: function() {
    const $body = $('body');
    const hasPageNav = $body.find("[data-has-pagenav]").length > 0;

    if(hasPageNav) {
      $body.addClass('has-pagenav');
      this.attachHandlers();
      this.initNavBar();

      this.sections.forEach( section => {
        this.observer.observe(section);
      }); 
    };
    
  },

  initNavBar: function() {
    const $html = $('html');
    const $body = $('body');
    const $el = $('.js-page-nav');
    const $sections = $('[data-section-name]').toArray();
    const $navContainer = $body.find("[data-has-pagenav]");
    const $pageTitle = $navContainer.attr('data-page-title');

    $html.addClass('landing-navlink-offset');

    $el.empty().append(`
      <div class="page-nav__navbar-container">
        <div class="navbar-content">
          <p class="page-title">${$pageTitle}</p>
          <div class="page-nav__navbar-title js-navbar-open">
            <p class="navbar-toggle-open js-navbar-title">${$sections[0].dataset.sectionName}</p>
            <div class="navbar-arrow-icon">${svgPageNavIcon}</div>
          </div>
          <div class="navbar-expanded" style="display: none;">
            ${ $sections.map(function(section, index) {
              const sectionLink = section.id;
              if(section.dataset.sectionName) {
                return `
                  <a 
                    class="navbar-link js-navbar-link" 
                    href="#${sectionLink}"
                    data-tracking-click
                    data-event-action="Nav - Link Click"
                    data-event-category="${$pageTitle}"
                    data-event-label="${section.dataset.sectionName}"
                  >
                    ${section.dataset.sectionName}
                  </a>`;
              }
            }).join('')}
          </div>
      </div>
    </div>
    `);
  },

  attachHandlers: function() {
    const $document = $(document);

    $document.on('click', '.js-navbar-open', this.handleOpenNavbar);
    $document.on('click', '.js-navbar-link', this.handleCloseNav);
    $document.on('click', '.navbar-open', this.handleCloseNav);
  },

  handleOpenNavbar: function(e) {
    const $body = $('body');

    $body.addClass('navbar-open');
    $('.page-nav__navbar-title').addClass('navbar-link');
    $('.page-title').hide();
    $('.navbar-expanded').show();
  },

  handleCloseNav: function(e){
    const $body = $('body');

    $body.removeClass('navbar-open');
    $('.page-nav__navbar-title').removeClass('navbar-link');
    $('.page-title').show();
    $('.navbar-expanded').hide();
  },

  observer: new IntersectionObserver(function(entries, observer) {
    entries.forEach(entry => {
      if(entry.isIntersecting) {
        if(entry.target.dataset.sectionName){
          $('.js-navbar-title').html(entry.target.dataset.sectionName);
        }
      }
    })
  }, this.options)
};

$(function() {
  window.ettitude = window.ettitude || {};
  Object.create(PageNavController).init();
});